import OptimizedImage from './OptimizedImage';

export default OptimizedImage; 